import React from 'react';
import { classNames } from '../../utilities/css.js';
import styles from './Indicator.scss.js';
function Indicator(_ref) {
  var _ref$pulse = _ref.pulse,
    pulse = _ref$pulse === void 0 ? true : _ref$pulse;
  var className = classNames(styles.Indicator, pulse && styles.pulseIndicator);
  return /*#__PURE__*/React.createElement("span", {
    className: className
  });
}
export { Indicator };